
(function ($, document) {
    $(document).ready(function () {
        $(document).on('click', '.js-product-filter__title', function (e) {
            $(this).toggleClass('active');
            $('.js-product-filter__container').toggleClass('active');
        });
    });

})(jQuery, document, Crafted.Utilities);